/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './user-profile-root.module';
export * from './feature-name';
export * from './facade/index';
export * from './model/index';

/** AUGMENTABLE_TYPES_START */
export { Title, UserSignUp } from './model/user-profile.model';
/** AUGMENTABLE_TYPES_END */
